/**
 * Created by Ivan on 07.01.2026
 */

const RiddlesLevelMasteryHorizontal = cc.Node.extend({
    ctor: function (mission, {
        closeWindowCallback
    }) {
        this._super();
        this.mission = mission;
        this.closeWindowCallback = closeWindowCallback;
        const style = cleverapps.styles.RiddlesLevelMasteryHorizontal;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(style.content.size);
        this.createBorder();
        this.createBg();

        this.createDecoration();

        this.createImage();

        const timer = this.createTimer();
        timer.setAlignment(style.timer);
        this.addChild(timer, 20);

        const scrollTop = style.stagesList.y.dy + this.height;
        const scrollHeight = scrollTop - (timer.y + timer.height / 2) + style.stagesList.extraReach;

        const scroll = this.createScroll(scrollHeight);
        scroll.setAlignment(style.stagesList);
        this.addChild(scroll);

        this.createFg();

        const progressBar = new RiddlesLevelMasteryWindowComponent(this.mission.logic);
        progressBar.setAlignment(style.progressBar);
        this.addChild(progressBar, 15);

        this.createHeader();
    },

    createHeader: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal.title;

        const title = cleverapps.UI.generateOnlyText(Messages.get("LevelMasteryWindow.Title"), cleverapps.styles.FONTS.RIDDLES_LEVEL_MASTERY_HOR_WINDOW_MAIN_TITLE_TEXT);
        title.setAlignment(styles);
        this.addChild(title);

        this.createHelpButton();
        this.createCloseButton();
    },

    createHelpButton: function () {
        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.mission);
            }
        });
        helpButton.setAnchorPoint(0.5, 0.5);
        this.addChild(helpButton, 2);
        helpButton.setAlignment(cleverapps.styles.RiddlesLevelMasteryHorizontal.helpButton);
    },

    createBorder: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;

        const sprite = styles.border.image;

        const image = cleverapps.skins.getSlot("windowBg", {
            image: sprite
        });

        const border = this.border = cleverapps.UI.createScale9Sprite(image, styles.border.scale9);

        if (styles.border.opacity) {
            border.setOpacity(styles.border.opacity);
        }

        this.border.setContentSize(styles.content.size.width + styles.border.padding.x, styles.content.size.height + styles.border.padding.y);
        this.border.setAlignment(styles.border.position);

        border.setLocalZOrder(0);
        this.addChild(border);
    },

    createBg: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;

        const bg = cleverapps.UI.createScale9Sprite(bundles.levelmastery_window.frames.background_png, cleverapps.styles.Window.Background.scale9);
        bg.setContentSize2(styles.bg.size);
        bg.setAlignment(styles.bg);
        this.addChild(bg);

        const pattern = new cleverapps.Spine(bundles.levelmastery_window.jsons.background_pattern_json);
        pattern.setAnimation(0, "horizontal", true);
        pattern.setAlignment(styles.bg);
        this.addChild(pattern);
    },

    createCloseButton: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal.closeButton;
        const closeButton = new cleverapps.UI.Button({
            type: {
                button_png: bundles.buttons_main.frames.window_close_png,
                button_on_png: bundles.buttons_main.frames.window_close_on_png
            },
            onClicked: this.closeWindowCallback
        });
        closeButton.setAlignment(styles);
        this.addChild(closeButton, 2);
    },

    createImage: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;

        const image = new cc.Sprite(bundles.levelmastery_window.frames.head_picture_png);
        this.addChild(image);
        image.setAlignment(styles.headPicture);
    },

    createFg: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const fg = new cc.Node();
        fg.setContentSize2(styles.fg.size);
        fg.setAlignment(styles.fg.position);
        this.addChild(fg);

        const top = new cc.Scale9Sprite(bundles.levelmastery_window.frames.foreground_png);
        top.setContentSize2(styles.fg.top);
        top.setAlignment(styles.fg.top);
        fg.addChild(top);

        return fg;
    },

    createScroll: function (height) {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const rows = this.mission.logic.getStageRewards().map(this.createRow.bind(this));
        const list = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.stagesList.margin,
            padding: styles.stagesList.padding,
            reversed: true
        });

        const scroll = new cleverapps.UI.ScrollView(list, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL,
            childrenVisibility: false
        });
        const width = styles.stagesList.size[cleverapps.resolution.mode].width;
        scroll.setContentSize(width, height);
        scroll.scrollTo(rows[this.mission.logic.stage]);

        return scroll;
    },

    createRow: function (reward, stage) {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const circle = this.createCircle(stage);
        const rewardCard = this.createRewardCard(reward, stage);

        return new cleverapps.Layout([circle, rewardCard], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.stageRow.margin,
            padding: styles.stageRow.padding
        });
    },

    createCircle: function (stage) {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const isCompleted = this.mission.logic.isCompleted(stage);
        const isCurrent = this.mission.logic.isCurrent(stage);
        const isLast = this.mission.logic.isLastStage(stage);
        const isLocked = !isCurrent && !isCompleted;

        const circle = new cc.Node();
        circle.setAnchorPoint(0.5, 0.5);

        const circleBg = new cc.Sprite(bundles.levelmastery.frames.circle_bg);
        circle.setContentSize(circleBg.getContentSize());
        circleBg.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(circleBg);

        const circleColored = new cc.Sprite(isCompleted ? bundles.levelmastery.frames.circle_green : bundles.levelmastery.frames.circle_blue);
        circleColored.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(circleColored);

        const stageNumber = cleverapps.UI.generateImageText(stage + 1, cleverapps.styles.FONTS.RIDDLES_LEVEL_MASTERY_HOR_WINDOW_CIRCLE_TITLE_TEXT);
        stageNumber.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        circle.addChild(stageNumber);

        if (isCurrent) {
            StandartAnimations.rays(circle, { skin: "white" });
        }

        if (!isLast) {
            const line = cleverapps.UI.createScale9Sprite(bundles.levelmastery.frames.line);
            line.setLocalZOrder(-1);
            line.setAnchorPoint(0.5, 0);
            line.setContentSize(styles.stageRow.circle.line);
            line.setAlignment(styles.stageRow.circle.line);
            circle.addChild(line);
        }

        if (isLocked) {
            circleBg.setScale(0.8);
            circleColored.setScale(0.8);
            stageNumber.setScale(0.8);
        }

        return circle;
    },

    createRewardCard: function (reward, stage) {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const isCompleted = this.mission.logic.isCompleted(stage);
        const isCurrent = this.mission.logic.isCurrent(stage);
        const isLocked = !isCurrent && !isCompleted;

        const card = cleverapps.UI.createScale9Sprite(isCompleted ? bundles.levelmastery.frames.card_bg_white : bundles.levelmastery.frames.card_bg);
        card.setContentSize(styles.stageRow.card);

        const icon = isCompleted ? new cc.Sprite(bundles.levelmastery.frames.card_mark) : new RiddlesLevelMasteryRewardView(reward);
        icon.setAlignment(styles.stageRow.card.icon);
        cleverapps.UI.fitToBox(icon, styles.stageRow.card.icon);
        card.addChild(icon);

        if (isLocked) {
            const lock = new cc.Sprite(bundles.levelmastery.frames.card_lock);
            lock.setAlignment(styles.stageRow.card.lock);
            card.addChild(lock);
        }

        return card;
    },

    createTimer: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal;
        const timer = new RiddlesLevelMasteryTimer(this.mission.logic.countDown, styles.timer);
        timer.setVisible(this.mission.logic.getTimeLeft() > 0);
        this.mission.logic.on("timeout", () => timer.setVisible(false));
        return timer;
    },

    createDecoration: function () {
        const styles = cleverapps.styles.RiddlesLevelMasteryHorizontal.decoration;

        const decorationLeft = new cc.Sprite(bundles.levelmastery_window.frames.crystals_decor_png);
        this.addChild(decorationLeft, 25);
        decorationLeft.setAlignment(styles.crystals.left);

        const decorationRight = new cc.Sprite(bundles.levelmastery_window.frames.crystals_decor_png);
        this.addChild(decorationRight, 25);
        decorationRight.setScaleX(-1);
        decorationRight.setAlignment(styles.crystals.right);

        const flashlightLeft = new cc.Sprite(bundles.levelmastery_window.frames.flashlight_png);
        this.addChild(flashlightLeft);
        flashlightLeft.setAlignment(styles.flashlight.left);

        const flashlightRight = new cc.Sprite(bundles.levelmastery_window.frames.flashlight_png);
        this.addChild(flashlightRight);
        flashlightRight.setAlignment(styles.flashlight.right);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_LEVEL_MASTERY_HOR_WINDOW_MAIN_TITLE_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },
    RIDDLES_LEVEL_MASTERY_HOR_WINDOW_CIRCLE_TITLE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },
    RIDDLES_LEVELMASTERY_HOR_WINDOW_TIMER_TEXT: {
        name: "nostroke",
        size: 48,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.RiddlesLevelMasteryHorizontal = {
    content: {
        size: { width: 780, height: 1070 }
    },

    closeButton: {
        x: { align: "right", dx: -5 },
        y: { align: "top", dy: 90 }
    },

    title: {
        x: { align: "center" },
        y: { align: "top", dy: 90 }
    },

    border: {
        image: bundles.windows.frames.window_bg_png,
        scale9: cleverapps.UI.Scale9Rect.TwoPixelXY,
        padding: {
            x: 40,
            y: 130
        },

        position: {
            x: { align: "left", dx: -20 },
            y: { align: "bottom", dy: -28 }
        }
    },

    helpButton: {
        x: { align: "left", dx: 30 },
        y: { align: "top", dy: 70 }
    },

    bg: {
        size: [
            { width: 780, height: 1000 },
            { width: 780, height: 1000 },
            { width: 780, height: 1000 }
        ],
        x: { align: "center" },
        y: { align: "center", dy: -30 }
    },

    fg: {
        position: {
            x: { align: "center" },
            y: { align: "top", dy: -295 }
        },
        size: [
            { width: 800, height: 966 },
            { width: 800, height: 760 },
            { width: 800, height: 760 }
        ],
        top: {
            x: { align: "center" },
            y: { align: "top", dy: -20 },
            width: 890,
            height: 70
        }
    },

    fgBottom: {
        x: { align: "center" },
        y: { align: "bottom", dy: 54 }
    },

    progressBar: {
        x: { align: "center" },
        y: { align: "top", dy: -200 }
    },

    stagesList: {
        x: { align: "center" },
        y: { align: "top", dy: -370 },
        size: [
            { width: 800, height: 630 },
            { width: 800, height: 630 },
            { width: 800, height: 630 }
        ],
        extraReach: 8,

        margin: 20,
        padding: {
            top: 0,
            bottom: 0
        }
    },

    stageRow: {
        margin: 80,
        padding: {
            left: 20,
            right: 0
        },

        circle: {
            line: {
                width: 27,
                height: 180,
                x: { align: "center" },
                y: { align: "center", dy: 90 }
            }
        },

        card: {
            width: 330,
            height: 178,

            icon: {
                x: { align: "center", dx: 10 },
                y: { align: "center" },
                width: 270,
                height: 98
            },

            lock: {
                x: { align: "right", dx: 18 },
                y: { align: "bottom", dy: -20 }
            }
        }
    },

    timer: {
        x: { align: "center" },
        y: { align: "bottom", dy: -98 },
        font: cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_HOR_WINDOW_TIMER_TEXT,
        countDown: {
            x: { align: "center", dx: 30 },
            y: { align: "center", dy: 10 },
            width: 200
        },
        icon: {
            frame: bundles.levelmastery.frames.clock,
            x: { align: "left", dx: 70 },
            y: { align: "center", dy: 7 }
        },
        padding: 0,
        background: {
            frame: bundles.levelmastery_window.frames.timer_bg_png,
            width: 430
        }
    },

    decoration: {
        crystals: {
            left: {
                x: { align: "left", dx: -63 },
                y: { align: "bottom", dy: -30 }
            },

            right: {
                x: { align: "right", dx: 63 },
                y: { align: "bottom", dy: -30 }
            }
        },

        flashlight: {
            left: {
                x: { align: "left", dx: -70 },
                y: { align: "center", dy: 75 }
            },

            right: {
                x: { align: "right", dx: 70 },
                y: { align: "center", dy: 75 }
            }
        }
    },

    headPicture: {
        x: { align: "center" },
        y: { align: "top", dy: 5 }
    }
};